export const GET_MEMBERS = 'GET_MEMBERS';
export const GET_MANAGERS = 'GET_MANAGERS';
export const REMOVE_MEMBERS = 'REMOVE_MEMBERS';
export const SET_PERMISSIONS_MEMBERS = 'SET_PERMISSIONS_MEMBERS';
export const DEEP_LINK = 'DEEP_LINK';
export const GET_MAP_FOLLOWER_DETAILS = 'GET_MAP_FOLLOWER_DETAILS';
